import React, { useState, useEffect } from "react";
// import { Link } from 'react-router-dom';
import { Container, Col, Row } from "bootstrap-4-react";

import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { Mousewheel, EffectFade, Thumbs } from "swiper";

// swiper bundle styles
import "swiper/swiper-bundle.min.css";

// swiper core styles
import "swiper/swiper.min.css";

import propertiesLogo from "./../../../assets/img/2020_Properties_Assets-08.svg";
import dotImage from "./../../../assets/img/2020_Properties_Assets-23.svg";

import axios from "axios";
import * as apiUrl from "../../../apiUrl";
import { useParams } from "react-router-dom";

// install Swiper modules
SwiperCore.use([Mousewheel, EffectFade, Thumbs]);

export default function PropertiesLocationSwiper() {

  const { id } = useParams();

  const [data, setData] = useState({
    formValues5: [
      {
        section_id: "",
        slider_image: [],
        imageURL: "",
        amenties_heading: "",
        duration: "",
      },
    ],
    errors5: [{ section_id: "", slider_image: "" }],
    selectedFiles7: undefined,
    currentFile7: undefined,
    imageURL7: "",
    section_title7: "",
    section_description7: "",
    section_title8: "",
  });

  const [thumbsSwiper, setThumbsSwiper] = useState(null);


  useEffect(()=>{

    //code here
    // when userName state change it will call 
    
    let self = this;
    const windowUrl = window.location.href;
    let dataxx = windowUrl.split("properties-inner/");
    axios
      .post(
        apiUrl.apiUrl +
          "/propertiesinnerpage/edit_propertiesinner_post/" +
          dataxx[1]
      )
      .then((res) => {
        let formValues5 = [];
        res.data[0].sports.forEach((element) => {
          element.imageURL =
            apiUrl.apiUrl +
            "/mvd/propertiesinnerpagepostsection/" +
            element.slider_image;
          formValues5.push(element);
        });
        let dataxx = [];
        dataxx.section_title7 = res.data[0].section_title7;
        dataxx.formValues5 = formValues5;
        setData(dataxx);
      });

},[id])


  useEffect(() => {
    let self = this;
    const windowUrl = window.location.href;
    let dataxx = windowUrl.split("properties-inner/");
    axios
      .post(
        apiUrl.apiUrl +
          "/propertiesinnerpage/edit_propertiesinner_post/" +
          dataxx[1]
      )
      .then((res) => {
        let formValues5 = [];
        res.data[0].sports.forEach((element) => {
          element.imageURL =
            apiUrl.apiUrl +
            "/mvd/propertiesinnerpagepostsection/" +
            element.slider_image;
          formValues5.push(element);
        });
        let dataxx = [];
        dataxx.section_title7 = res.data[0].section_title7;
        dataxx.formValues5 = formValues5;
        setData(dataxx);
      });
  }, []);

 console.log("location", data.formValues5);

  return (
    <Container fluid className="propLocationSec">
      <Row>
        <Col lg={1}></Col>
        <Col lg={11} className="paddingZero">
          <Row className="marginZero">
            <Col lg={12} className="">
              <Swiper
                spaceBetween={10}
                onSwiper={setThumbsSwiper}
                effect={"fade"}
                className="propertiesDesContent"
              >
                {data.formValues5.map((item) => (
                  <SwiperSlide key={"Properties_location_swiper_" + item.id}>
                    <div className="sliderTopImage">
                      <div className="logoPosition">
                        <img
                          src={propertiesLogo}
                          className="img-fluid animated speed2 fadeInUp"
                          alt="propertieslogo"
                        />
                      </div>
                      <div className="logoOntext">
                        <p className="darkBlue canelaMedium">
                          {item.place_name}
                        </p>
                        {/* <span className="darkBlue canelaMedium">
                          {data.section_title7}
                        </span> */}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
            <Col lg={12} className="paddingZero">
              <div className="placesSliderSec marginLeft">
                <Swiper
                  thumbs={{ swiper: thumbsSwiper }}
                  spaceBetween={50}
                  slidesPerView={5}
                  mousewheel={true}
                  loop={true}
                  centeredSlides={true}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    420: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                    1280: {
                      slidesPerView: 5,
                    },
                  }}
                  className="swiperPlaces"
                >
                  {data.formValues5.map((item) => (
                    <SwiperSlide
                      key={"Properties_location_swiper123456_" + item.id}
                    >
                      <div className="sliderBottomImage">
                        <div className="bottomImage">
                          <img
                            className="img-fluid"
                            src={item.imageURL}
                            alt="owl img src"
                          />
                        </div>
                        <div className="dotImage">
                          <img
                            className="img-fluid"
                            src={dotImage}
                            alt="owl img src"
                          />
                        </div>
                        <div className="bottomSliderText darkBlue canelaMedium">
                          <p>{item.duration}</p>
                          <span>Minutes</span>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={1}></Col>
      </Row>
    </Container>
  );
}
